module.exports = __webpack_public_path__ + "media/images/camping-e7e3744d5840741bba81255904ca9572.png";